<template>
  <div>
    <el-tabs v-model="form.integralOrderState" @tab-click="handleClick">
      <el-tab-pane
        :label="`全部(${countInfo.countAll})`"
        name="0"
      ></el-tab-pane>
      <el-tab-pane
        :label="`待发货(${countInfo.countSend})`"
        name="4"
      ></el-tab-pane>
      <el-tab-pane
        :label="`待收货(${countInfo.countWaitReceive})`"
        name="1"
      ></el-tab-pane>
      <el-tab-pane
        :label="`待自提(${countInfo.countTakeByMyself})`"
        name="2"
      ></el-tab-pane>
      <el-tab-pane
        :label="`已完成(${countInfo.countFinish})`"
        name="3"
      ></el-tab-pane>
    </el-tabs>
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="输入搜索">
          <el-input
            clearable
            v-model="form.id"
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input
            clearable
            v-model="form.searchKeyWord"
            placeholder="收货人姓名/手机号吗"
          ></el-input>
        </el-form-item>
        <el-form-item label="店铺名称">
          <el-select
            clearable
            v-model="form.shopId"
            placeholder="请选择店铺名称"
          >
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.shopName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换时间：">
          <el-date-picker
            v-model="date1"
            clearable
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="订单编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="兑换时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userName"
          label="拥有账号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalIntegralNum"
          label="抵扣积分"
          align="center"
        ></el-table-column>
        <el-table-column label="配送方式" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.integralOrderType == 1">快递配送</span>
            <span v-else>门店自提</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center">
          <template slot-scope="scope">
            {{ orderStatusObj[scope.row.integralOrderState] }}
          </template>
        </el-table-column>
        <el-table-column label="兑换店铺" align="center">
          <template slot-scope="scope">
            {{ scope.row.shopName || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" @click="onLook(scope.row)"
                >查看订单</el-button
              >
              <el-button
                type="text"
                @click="onExpress(scope.row)"
                v-if="scope.row.integralOrderState == 4"
                >发货</el-button
              >
              <el-button
                type="text"
                v-if="
                  scope.row.integralOrderState == 4 ||
                    scope.row.integralOrderState == 2
                "
                @click="onReplace(scope.row)"
                >订单转换</el-button
              >
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- 发货 -->
      <DeliverDialog
        :visible.sync="showDelivery"
        :loading="loading1"
        @confirm="onConfirmDelivery"
      >
      </DeliverDialog>
      <!-- 转自提 -->
      <SelectShopDialog
        :visible.sync="showSelectShop"
        :options="shopList"
        :loading="loading2"
        @confirm="onReplaceShop"
      >
      </SelectShopDialog>
      <!-- 转快递 -->
      <SelectDeliverDialog
        :visible.sync="showSelectDeliver"
        :loading="loading3"
        @confirm="onReplaceDelivery"
      >
      </SelectDeliverDialog>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import DeliverDialog from './components/DeliverDialog.vue';
import SelectShopDialog from './components/SelectShopDialog.vue';
import SelectDeliverDialog from './components/SelectDeliverDialog.vue';
import Excel from '@/mixins/export';
import { getShopList } from '@/api/stores';
import {
  addExpressCompany,
  getExchangeOrderList,
  getCountParams,
  exportOrders,
  replaceOrder,
} from '@/api/exchange';

import { orderStatusObj } from '@/utils/util';

export default {
  mixins: [Excel],
  name: 'orderList',
  components: {
    Pagination,
    DeliverDialog,
    SelectShopDialog,
    SelectDeliverDialog,
  },
  data() {
    return {
      orderStatusObj,
      date1: '',
      form: {
        id: '',
        integralOrderState: '',
        searchKeyWord: '',
        shopId: '',
        beginTime: '',
        endTime: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
      shopList: [],
      countInfo: {
        countAll: 0,
        countWaitReceive: 0,
        countTakeByMyself: 0,
        countFinish: 0,
        countSend: 0,
      },
      showDelivery: false,
      showSelectShop: false,
      showSelectDeliver: false,
      currentOrder: '', // 当前订单
      loading1: false,
      loading2: false,
      loading3: false,
    };
  },
  mounted() {
    this.getShop();
    this.getList();
    this.getCount();
  },
  methods: {
    getCount() {
      getCountParams().then((res) => {
        if (res.success) {
          this.countInfo = res.data;
        }
      });
    },
    getShop() {
      getShopList({
        page: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.shopList = res.data.list || [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getList() {
      const [beginTime = '', endTime = ''] = this.date1 || [];
      const params = {
        ...this.form,
        beginTime,
        endTime,
        integralOrderState: Number(this.form.integralOrderState) || '',
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      this.loading = true;
      getExchangeOrderList(params).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    handleClick() {
      this.currentPage = 1;
      this.getList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    onSearch() {
      this.currentPage = 1;
      this.getList();
    },
    onExport() {
      const [beginTime = '', endTime = ''] = this.date1 || [];
      const params = {
        ...this.form,
        beginTime,
        endTime,
        integralOrderState: Number(this.form.integralOrderState) || '',
      };
      exportOrders(params).then((res) => {
        this.exportExcel(res, '积分订单列表');
      });
    },
    onLook({ id }) {
      this.$router.push({
        path: 'detail',
        query: { id },
      });
    },
    // 发货
    onExpress(item) {
      this.currentOrder = item;
      this.showDelivery = true;
    },
    onConfirmDelivery(data) {
      this.loading1 = true;
      addExpressCompany({ id: this.currentOrder.id, ...data }).then((res) => {
        this.loading1 = false;
        if (res.success) {
          this.$message.success('发货成功');
          this.showDelivery = false;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 订单转换
    onReplace(item) {
      const { integralOrderType } = item;
      this.currentOrder = item;
      if (integralOrderType === 1) {
        // 快递转自提
        this.showSelectShop = true;
      } else {
        this.showSelectDeliver = true;
      }
    },
    // 快递转自提
    onReplaceShop(data) {
      this.onReplaceOperate(data, 'loading2', 'showSelectShop');
    },
    // 自提转快递
    onReplaceDelivery(data) {
      this.onReplaceOperate(data, 'loading3', 'showSelectDeliver');
    },
    onReplaceOperate(data, loadingKey, showKey) {
      const { id, integralOrderState, integralOrderType } = this.currentOrder;
      const params = {
        id,
        integralOrderState,
        integralOrderType,
        ...data,
      };
      this[loadingKey] = true;
      replaceOrder(params).then((res) => {
        this[loadingKey] = false;
        if (res.success) {
          this.$message.success('操作成功');
          this[showKey] = false;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.table-search
  padding-top: 10px;
</style>
